"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
var _default = exports.default = {
  suggest: {
    approvalCompleted: '审批完成',
    approval: '审批中',
    selectResponsibleDepartment: '请选择责任部门',
    recommendationTracking: '意见/建议跟踪',
    managementReviewRecord: '管理评审记录',
    noComplete: '未完成船舶监控',
    reportCannotEmpty: '评审报告所有内容不能为空',
    attachmentsCannotEmpty: '会议签到表及其他附件不能为空',
    cannotBeEmpty: 'cannotBeEmpty责任部门意见不能为空',
    postBeforeSubmit: '请发布所有文件/表格之后再提交',
    isComplete: '是否完成',
    saveAndSubmit: '请先保存再提交',
    expectedPortReceipt: '预计收货港口',
    tableName: '表格名称',
    ETA: 'ETA',
    ETD: 'ETD',
    inquiryLogo: '询价标识',
    receivingTime: '接收时间(岸端)',
    transferStatus: '调拨标识',
    transferNo: '调拨单号',
    memo: '申请说明/联系方式',
    download: '下载',
    formNumber: '表格编号',
    newRecordTable: '新增记录表格',
    updateRecordTable: '更新记录表格',
    Annexeleased: '附件(拟发布)',
    attachedOriginalProposal: '附件(原始建议)',
    copyAttach: '复制原始文件',
    newSystemFile: '新增体系文件',
    fileInformation: '文件信息',
    historicalVersion: '历史版本',
    updateSystemDocuments: '更新体系文件',
    operationType: '操作类型',
    complete: '完成',
    applicationInformation: '申请信息',
    confirmDelete: '是否确认删除',
    confirmDeleteRecord: '是否确认删除该记录',
    operationFailure: '操作失败',
    operationSuccessful: '操作成功',
    isCompleteState: '是否设置此计划为完成状态?',
    completed: '已完成',
    unfinished: '未完成',
    cancelRelease: '取消发布',
    postFailure: '发布失败',
    releaseSuccess: '发布成功',
    noChange: '发布后此处不可更改，如需修改请前往文件管理模块修改！确认发布吗?',
    selectRejectNode: '请选择驳回节点',
    actualCompletion: '实际完成情况',
    networkErrorTryAgain: '网络networkErrorTryAgain错误，请稍后再试',
    pleaseSave: '请先进行保存',
    selectApprovalAction: '请选择审批操作!',
    submittedSuccessfully: '提交成功!',
    submissionFailed: '提交失败',
    selectPointRejection: '请选择驳回点',
    changesApplication: '变更申请',
    tableInvolved: '涉及表格',
    chaptersInvolved: '涉及章节',
    workflow: '审批历史',
    applicationDate: '申领日期',
    actionPlanCannotBeEmpty: '行动计划不能为空',
    confirmSubmissionRecord: '是否确认提交该记录',
    addFormFist: '请先添加变更管理风险评估列表!',
    selectDate: '请选择预计完成日期',
    common: {
      temporaryStorage: '暂存',
      saveAndSubmit: '保存并提交',
      through: '通过',
      reject: '驳回',
      approved: '审核通过',
      submit: '提交'
    },
    vesselOpinion: {
      department: '部门',
      vesselName: '船舶',
      fleet: '船队',
      managementCompany: '管理公司',
      reviewTime: '评审日期',
      captainName: '船长',
      suggestionsForImprovement: '纠正和预防措施或改进建议',
      responsibleDepartment: '责任部门',
      opinionsOfResponsibleDepartment: '责任部门意见',
      needToTrack: '是否需要跟踪',
      expectedCompletionDate: '预计完成日期',
      actualFinishingDate: '实际完成日期',
      completedBy: '完成人',
      attachment: '相关附件',
      reportNo: '报告编号'
    },
    improveSuggest: {
      copyQuestion: '复制原始试题',
      title: '体系运行',
      item: '体系改进',
      advice: '体系改进计划',
      proposal: '船舶意见/建议跟踪',
      chapterNo: '章节编号',
      record: '体系改进建议',
      shipStart: '发起',
      shoreStart: '岸端发起',
      shoreApprove: '岸端审批',
      reviseDocument: '安质办修订文件',
      reviseApprove: '修订后审批',
      baseInfo: '基本信息',
      publish: '安质办发布',
      updateFile: '更新文件',
      updateFileaOrDraft: '更新文件/表格草稿',
      upLoadFile: '上传文件',
      approveHistory: '审批历史',
      issueDocument: '拟发布文件',
      handlingOpinions: '处理意见',
      query: {
        status: '改进状态',
        vesselCode: '船舶',
        date: '日期',
        itemName: '项目名称'
      },
      table: {
        workNum: '工作编号',
        suggestPerson: '发起人',
        suggestOrg: '发起人部门/船舶',
        suggestDate: '发起日期',
        suggest: '改进建议',
        attachmentsName: '文件列表',
        validFlag: '状态',
        detail: '详情'
      },
      form: {
        department: '主管部门',
        sysOrgId: '公司部门',
        workNum: '工作编号',
        suggestData: '建议日期',
        suggestFileChapterNo: '体系文件章节号',
        suggestFileName: '体系文件名称',
        recordFormNo: '记录表格编号',
        recordFormName: '记录表格名称',
        suggester: '建议人',
        suggest: '改进建议',
        qualityFileNo: '文件编号',
        qualityFileName: '文件名称',
        contextFile: '正文文件',
        commonOpinions: '常用意见',
        auditMind: '审核意见',
        appendix: '补充附件',
        approveTime: '审批时间',
        approver: '审批人',
        approveFlag: '审批状态',
        approveOpinions: '审批意见',
        approvedDept: '审批部门',
        granter: '授权人',
        attachmented: '附件(原始建议)',
        attachmenting: '附件(拟发布)',
        attachment: '附件'
      },
      message: {
        attach: '请先上传附件(拟发布)'
      }
    },
    improvePlan: {
      title: '体系运行',
      item: '体系改进计划',
      query: {
        chapter: '章节号',
        chapterName: '章节名称',
        date: '修改日期'
      },
      table: {
        qualityFileChapter: '文件编号',
        qualityFileChapterName: '文件名称',
        updateContext: '修改内容描述',
        source: '理由来源',
        planDate: '计划修改日期',
        validFlag: '状态',
        completedBy: '操作人',
        completedDate: '操作日期',
        fileKeyWord: '体系文件章节号/记录表格编号/文件名称'
      },
      form: {
        source: '理由来源',
        planDate: '计划修改日期',
        qualityFileChapter: '文件编号',
        qualityFileChapterName: '文件名称',
        updateContext: '修改内容描述'
      }
    },
    moc: {
      title: '体系运行',
      item: '变更管理',
      applyStart: '变更申请发起',
      reportStart: '变更申请发起',
      applyStartAudit: '变更申请审批',
      reportStartAudit: '变更申请审批',
      upAttachment: '上传附件',
      changeReport: '变更报告',
      query: {
        vesselCode: '涉及船舶',
        applicant: '申请人',
        changeDept: '申请部门',
        status: '状态',
        date: '申请日期',
        applicationNo: '申请单号',
        applicationCategory: '申请类别',
        degreeEmergency: '紧急程度',
        degreeEmergencyAn: '紧急程度(岸端)',
        applyReason: '申请理由',
        purpose: '使用目的'
      },
      table: {
        workNum: '工作编号',
        applicant: '申请人',
        changeDept: '申请部门',
        applyDate: '申请日期',
        changeItem: '变更项目',
        changeType: '变更类型',
        currentSteps: '当前步骤',
        taskResponse: '任务完成情况',
        validFlag: '状态',
        details: '详情',
        changeInfoAndDetail: '变更理由及描述'
      },
      form: {
        item: {
          baseInfo: '基础信息',
          changeInfo: '变更理由',
          riskAssessment: '变更管理风险评估',
          activePlan: '行动计划',
          processInfo: '流程信息'
        },
        attachment: {
          attachmentType: '附件类型',
          isTransfer: '是否需要传输',
          attachmentsName: '附件名称',
          upDate: '上传时间',
          department: '上传部门',
          upBy: '上传人'
        },
        yes: '是',
        no: '否',
        changeType: '变更类型',
        changeItem: '变更项目',
        vesselCode: '涉及船舶',
        Dept: '申请部门',
        applicant: '申请人',
        applyDate: '申请日期',
        applyNo: '申请编号',
        approveDate: '审批批准日期',
        changeDept: '变更涉及部门',
        changeDetail: '变更管理描述',
        changeInfoAndDetail: '变更理由及描述',
        changeInfoAndDetail1: '如果没有实施变更会有什么影响',
        changeInfoAndDetail2: '有关变更管理的会议纪要',
        attachmentsInfo: '附件',
        possibleRisk: '存在或可能存在的风险',
        possibility: '可能性',
        riskDegree: '影响程度',
        riskLevel: '风险等级',
        countermeasures: '应对措施',
        riskAndProblem: '发生风险或问题',
        controlAction: '将采取的控制行动',
        responseDept: '责任部门',
        responseDeptOpinion: '责任部门意见',
        trackFlag: '是否需要跟踪',
        completedDate: '预计完成日期',
        planCompletedTime: '计划完成时间',
        isUpdateAttachment: '体系文件是否需要修改',
        updateChapter: '体系修改章节',
        additionSource: '需额外人力资源',
        reSourceDescription: '人力资源描述',
        isFree: '是否产生费用',
        freeDetail: '费用描述',
        planExecuteTime: '计划执行时间',
        estimatedExecutionTime: '预计完成时间',
        otherRequire: '其他要求',
        changeImplementation: '变更实施'
      }
    }
  },
  shoreReview: {
    index: {
      title: '体系运行',
      item: '公司管理评审',
      review: '管理评审',
      meetingTrack: '会议跟进',
      baseInfo: '基本信息',
      attendanceMeetings: '会议签到表',
      reportingMaterials: '汇报材料',
      reviewReport: '评审报告',
      updateFileaOrDraft: '上传附件',
      query: {
        startBy: '发起人  ',
        relatedDept: '涉及部门',
        status: '状态',
        date: '发起日期'
      },
      table: {
        jobNo: '工作编号',
        startBy: '发起人',
        startDate: '发起日期',
        relatedDept: '涉及部门',
        status: '状态',
        meetingReview: '评审会议',
        valid: '任务完成情况',
        meetingTrack: '决议监控',
        detail: '详情'
      },
      form: {
        activityName: '活动名称',
        jobNo: '工作编号',
        company: '所属公司',
        examine: '查看',
        reviewDate: '评审日期',
        reviewtimeInterval: '评审时段',
        meetingType: '管理评审会议',
        ProposedDate: '建议日期',
        attachmentType: '附件类型',
        status: '是否需要传输',
        attachmentName: '附件名称',
        uploadDate: '上传时间',
        uploadDept: '上传部门',
        uploadPerson: '上传人',
        oprate: '操作'
      }
    }
  },
  shipReview: {
    index: {
      baseInfo: '基本信息',
      implementation: '落实情况',
      attachment: '附件',
      completeDescription: '完成说明',
      analysisCause: '原因分析',
      problems: '发现的突发问题',
      reviewContext: '评审内容',
      advice: '纠正和预防措施或改进建议',
      actualCompletionDate: '实际完成日期',
      plannedCompletionDate: '计划完成日期',
      implementationStatus: '落实完成情况',
      title: '体系运行',
      item: '船舶管理评审',
      time: '评审时段的开始时间应为上次评审时段结束时间的后一天',
      uncompletedSMSMonitor: '未完成SMS审批船舶监控',
      reviewRecord: '管理评审记录',
      remind: '提醒',
      managementReview: '管理评审',
      approve: '安质办审批',
      departmentApprove: '职能部门审批',
      summary: '安质办汇总',
      captainReceive: '船长接收',
      query: {
        vesselType: '船型',
        serviceLength: '任职时长',
        lastServiceLength: '距离上次评审日期时间',
        vesselCode: '涉及船舶',
        status: '状态',
        date: '发起日期'
      },
      table: {
        jobNo: '工作编号',
        startBy: '发起人',
        reviewTime: '评审时段',
        startDate: '发起日期',
        relatedShip: '涉及船舶',
        reviewDate: '评审日期',
        rectificationItem: '整改项(已完成/总数)',
        valid: '状态',
        details: '详情',
        completion: '完成情况',
        problems: '发现的突发问题',
        completionDate: '计划完成日期',
        finishedCondition: '完成状态'
      },
      form: {
        item: {
          baseInfo: '基础信息',
          changeInfo: '变更理由',
          riskAssessment: '变更管理风险评估',
          activePlan: '行动计划',
          processInfo: '流程信息'
        },
        attachment: {
          uploadAttachment: '上传附件',
          attachmentType: '附件类型',
          isTransfer: '是否需要传输',
          attachmentsName: '附件名称',
          upDate: '上传时间',
          department: '上传部门',
          upBy: '上传人'
        },
        dateRules: '完成日期不能为空',
        yes: '是',
        no: '否',
        activeName: '活动名称',
        jobNo: '工作编号',
        relatedShip: '涉及船舶',
        reviewDate: '评审日期',
        reviewtimeInterval: '评审时段',
        captainName: '船长',
        embarkationDate: '任职日期',
        others: '会议签到表及其他附件',
        reviewReport: '评审报告',
        reviewContext: '评审内容',
        outstandProblem: '发现的突出问题',
        analysisCause: '原因分析',
        advice: '纠正和预防措施或改进建议',
        operationAndMonitor: '体系运行与监控（抱括内外部文件资料、通函通告、证书、记录的更新、学习及管理等）',
        voyageExecution: '航次执行情况（包括货物运输和航行安全情况）',
        shipMaintenance: '船舶维修保养',
        crewManagement: '船员管理（包括船员的适任性、服从意识和培训等）',
        riskIdentityAndManager: '风险识别与管理',
        shipAccident: '船舶事故、险情和违章操作',
        boardingInspection: '公司登轮检查、内/外审情况',
        inspection: '港口国及外部机构检查',
        SSPExecution: 'SSP执行情况',
        MLCExecution: 'MLC执行情况',
        informationReflected: '安全生产活动日反映得情况',
        other: '其它',
        generalEvaluation: '总体评价 '
      }
    },
    uncompleted: {
      allVessel: '全部船舶',
      mineVessel: '我的船舶',
      vesselName: '船舶',
      captain: '船长',
      lengthOfService: '任职时长',
      embarkationDate: '任职日期',
      days: '天',
      all: '全部',
      lastReviewDate: '上次评审日期',
      lastReviewDay: '距上次评审已'
    },
    confirm: {
      tip: '提示',
      msgTip: '您在当前船舶任职时长小于90天,是否确认也发起管理评审',
      confirm: '确定',
      cancel: '取消',
      cancelReview: '已取消发起管理评审'
    }
  },
  moc: {
    public: {
      selectMsg: '请选择'
    }
  },
  recordBusinessJob: {
    postId: '负责岗位',
    ship: '船舶',
    title: '记录表格填报与查询',
    keyword: '记录编号/名称',
    businessActivities: '业务活动',
    recordNo: '记录编号',
    recordName: '记录名称',
    version: '版本号',
    revisionNo: '修订版本号',
    effectiveDate: '生效日期',
    storageLocation: '存放地点',
    shelfLife: '保存期限',
    formType: '表格类型',
    inSystemForms: '体系内记录表格',
    outSystemForms: '非体系记录表格'
  },
  recordJobManage: (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({
    lastJobDate: '上次填报日期',
    fillingContents: '填报内容',
    baseInfo: '基本信息',
    jobNo: '工作编号',
    draft: '草稿',
    processing: '进行中',
    completed: '已完成',
    vessel: '船舶',
    breadcrumbTitle: '工作列表',
    workDialogTitle: '记录表格填报',
    workNo: '工作编号',
    initWork: '发起工作',
    businessActivities: '业务活动',
    sponsorDept: '发起人部门',
    relatedForms: '涉及表格',
    status: '状态',
    startDate: '发起日期',
    sponsor: '发起人',
    sponsorPost: '发起人岗位'
  }, "sponsorDept", '发起人部门'), "vesselCode", '涉及船舶'), "voyageNo", '航次号'), "jobDescription", '工作描述'), "otherAttach", '其他附件'), "rules", {
    cannotEmpty: '不能为空',
    attach: '请先上传附件'
  }),
  monitorPeriodRecordJob: {
    record: '体系表格',
    job: '工作监控',
    monitorJob: '记录表格工作监控',
    vessel: '船舶',
    startByDept: '发起部门',
    normal: '正常',
    windowPeriod: '窗口期',
    overdue: '超期',
    startByVessel: '发起船舶',
    startByPost: '发起岗位',
    reportingCycle: '填报周期',
    plannedFillingDate: '计划填报日期',
    fillingDate: '填报日期',
    status: '状态',
    recordJobMonitor: {
      keyword: '编号/名称',
      no: '序号',
      num: '编号',
      name: '名称',
      version: '版本号'
    }
  }
};